import React from "react";
import { Modal } from "reactstrap";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const STATUS_META = {
  processed:    { color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0', iconPath: 'M5 13l4 4L19 7', label: 'Success', message: 'Your payment was successfully processed.' },
  held:         { color: '#d97706', bg: '#fffbeb', border: '#fde68a', iconPath: 'M12 8v4l3 2M12 21a9 9 0 110-18 9 9 0 010 18z', label: 'Payment On Hold', message: 'Your payment was received and is on hold. The funds will be available once the hold clears.' },
  error:        { color: '#dc2626', bg: '#fff5f5', border: '#fecaca', iconPath: 'M6 6l12 12M18 6L6 18', label: 'Error', message: 'Your payment was canceled or failed.' },
  expired:      { color: '#d97706', bg: '#fffbeb', border: '#fde68a', iconPath: 'M12 9v4M12 17h.01', label: 'Expired', message: 'Invalid or expired request.' },
  already_paid: { color: '#7c3aed', bg: '#faf5ff', border: '#ddd6fe', iconPath: 'M9 12l2 2 4-4', label: 'Already Paid', message: 'This invoice has already been paid.' },
  default:      { color: '#64748b', bg: '#f8fafc', border: '#e2e8f0', iconPath: 'M12 9v4M12 17h.01', label: 'Message Box', message: 'You have this message' },
};

const DepositPaymentResponseModal = ({ template, isOpen, setOpen, status, errorMessage }) => {
  const { t } = useTranslation();
  if (!template) return t("loading");

  const logo = `${process.env.REACT_APP_API_STORAGE_URL}/${template.big_logo}`;
  const meta = STATUS_META[status] ?? STATUS_META.default;
  const displayMessage = ((status === 'error' || status === 'held') && errorMessage) ? errorMessage : meta.message;

  return (
    <Modal isOpen={isOpen} className="deposit-response-modal" toggle={() => setOpen(false)}>
      <div className="deposit-response-modal__inner">

        <div className="deposit-response-modal__header">
          <img src={logo} alt="logo" className="deposit-response-modal__logo" />
          <button
            className="deposit-response-modal__close"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="deposit-response-modal__body">
          <div
            className="deposit-response-modal__icon-wrap"
            style={{ background: meta.bg, border: `1px solid ${meta.border}` }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke={meta.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d={meta.iconPath} />
            </svg>
          </div>

          <h3 className="deposit-response-modal__title" style={{ color: meta.color }}>
            {meta.label}
          </h3>

          <p className="deposit-response-modal__message">{displayMessage}</p>

          <button
            type="button"
            className="deposit-response-modal__btn"
            style={{ background: meta.color }}
            onClick={() => setOpen(false)}
          >
            Close
          </button>
        </div>

      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  template: state.domain?.program?.template,
});

export default connect(mapStateToProps)(DepositPaymentResponseModal);
